<template>
  <section class="monitoring__column">
    <div class="monitoring__column_header">
      <h6 class="monitoring__column_title"><strong>{{ location.name }}</strong></h6>
      <span @click="loadEvents(true)" class="monitoring__column_refresh_icon"><v-icon>refresh</v-icon></span>
    </div>

    <div class="monitoring__events_container">
      <virtual-list class="monitoring__column_scroll" :data-key="'id'" :data-sources="events" :data-component="item"
        :page-mode="false" v-on:tobottom="loadEvents()" :bottom-threshold="1" :estimate-size="193" :keeps="15">
        <div v-if="isLoading" slot="footer" class="monitoring__column_loading"><span class="monitoring__column_loading_icon"><v-icon>refresh</v-icon></span></div>
      </virtual-list>
      <div v-if="this.selectedEvents.length > 0" style="background-color: white;" class="monitoring__column_loading"><v-btn @click="sendToValidate" color="primary">Enviar para validación</v-btn></div>
    </div>
  </section>
</template>

<script>
import VirtualList from 'vue-virtual-scroll-list';

import EventItem from './EventItem.vue';
import events_service from '../../../services/events_service';
import itemClickEventBus from '../../../services/eventBus';
export default {
  name: 'MonitoringRow',
  components: {
    'virtual-list': VirtualList,
    // eslint-disable-next-line vue/no-unused-components
    EventItem,
  },
  props: {
    location: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      events: [],
      count: 0,
      item: EventItem,
      isLoading: false,
      lastRecordId: undefined,
      selectedEvents: [],
    };
  },
  mounted() {
    this.loadEvents(true);
    this.subscribeToFacialChannel();
    const self = this;
    itemClickEventBus.$on('item_click', (data) => {
      if (data.camera1.location_id === self.location.id) {
        self.selectEvents(data);
      }
    });
  },
  beforeDestroy() {
    this.unsubscribeFromFacialChannel();
    itemClickEventBus.$off('item_click')
  },
  methods: {
    selectEvents(pairEvents) {
      if (pairEvents.camera1.event_type !== 'UNKNOWN FACE' || pairEvents.camera2.event_type !== 'UNKNOWN FACE')
        return;
      pairEvents.selected = !pairEvents.selected;
      const indexOfItem = this.selectedEvents.findIndex(event => event.id === pairEvents.id);
      if (indexOfItem !== -1) {
        this.selectedEvents.splice(indexOfItem, 1);
        return;
      }
      this.selectedEvents.push(pairEvents);
    },
    loadEvents(reload = false) {
      if (this.isLoading) return;
      this.isLoading = true;
      const self = this;
      if (reload) this.lastRecordId = undefined;
      events_service.getPendingEvents({
          user_id: this.getUserId(),
          company_id: this.getSelectedCompany(),
          location_id: this.location.id,
          max_limit: 15,
          last_record_id: this.lastRecordId,
        },
        {
          'X-Device-ID': this.getDeviceId(),
        }
      ).then(response => {
        //TODO: validate and group events

        self.lastRecordId = response.data.last_record_id;

        const events = [];

        response.data.pending_events.forEach(event => {
          const id = `${event.id}_${event.id}`;
          events.push({
            id: id,
            event_time: event.event_time,
            camera1: event,
            camera2: event,
            location_id: self.location.id,
            emitEvent: true,
            showCroppedphoto: false,
            selected: false,
          });
        });

        if (reload) {
          self.events = events;
        } else {
          self.events.push(...events);
        }

      }).finally(() => {
        self.isLoading = false;
      })
    },
    subscribeToFacialChannel() {
      this.$cable.subscribe({
        channel: 'FaceNotificationsChannel',
        location_id: `${this.location.id}`
      })
    },
    unsubscribeFromFacialChannel() {
      this.$cable.unsubscribe();
    },
    async sendToValidate() {
      try {
        const events = this.selectedEvents.map(item => ({
          event_1: item.camera1.id,
          event_2: item.camera2.id
        }));
        const data = {
          company_id: this.getSelectedCompany(),
          data: events,
        }
        await events_service.sendToValidate({
          data: this.encrypt(data).toString()
        }, {
          'X-Device-ID': this.getDeviceId(),
          'Authorization': `Bearer ${this.getUserToken()}`
        });
        this.selectedEvents.forEach(item => item.selected = false);
        this.selectedEvents = [];
        
      } catch (err) {
        console.error();
      }
    }
  },
  channels: {
    FaceNotificationsChannel: {
      connected() {},
      received(data) {
        if (data.message.location_id == this.location.id) {
          this.loadEvents(true);
        }
      }
    }
  }
};
</script>
